import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import JSONTree from 'react-json-tree';
import { Button, Tab, Tabs } from 'react-bootstrap';
import { Modal } from '@storable/canaveral-components';
import classes from './EventModal.scss';

const JSON_TREE_THEME = {
  scheme: 'monokai',
  author: 'wimer hazenberg (http://www.monokai.nl)',
  base00: '#272822',
  base01: '#383830',
  base02: '#49483e',
  base03: '#75715e',
  base04: '#a59f85',
  base05: '#f8f8f2',
  base06: '#f5f4f1',
  base07: '#f9f8f5',
  base08: '#f92672',
  base09: '#fd971f',
  base0A: '#f4bf75',
  base0B: '#a6e22e',
  base0C: '#a1efe4',
  base0D: '#66d9ef',
  base0E: '#ae81ff',
  base0F: '#cc6633',
};

export default class EventModal extends React.Component {
  static propTypes = {
    onClose: PropTypes.func.isRequired,
    event: PropTypes.shape({
      id: PropTypes.string.isRequired,
      actor: PropTypes.object.isRequired,
      message: PropTypes.string.isRequired,
      context: PropTypes.object,
      diff: PropTypes.array,
    }),
  };

  renderObject(data) {
    return (
      <pre>
        {JSON.stringify(data, null, 2)}
      </pre>
    );
  }

  renderTree(data) {
    return <JSONTree data={data} theme={JSON_TREE_THEME} />;
  }

  renderDiff(diff) {
    if (!diff) {
      return this.renderObject(diff);
    }

    return (
      <Tabs defaultActiveKey={1} id="event-modal-diff-tab" animation={false}>
        <Tab eventKey={1} title="JSON">{this.renderObject(diff)}</Tab>
        <Tab eventKey={2} title="Tree">{this.renderTree(diff)}</Tab>
      </Tabs>
    );
  }

  renderBody() {
    const { event } = this.props;

    if (!event) {
      return 'Loading...';
    }

    return (
      <div className={classes.body}>
        <dl className="dl-horizontal">
          <dt>Event ID</dt>
          <dd><code>{event.id}</code></dd>

          <dt>Timestamp</dt>
          <dd><code>{moment(event.timestamp).format('YYYY-MM-DD HH:mm:ss (ZZ)')}</code></dd>

          <dt>Message</dt>
          <dd><pre>{event.message}</pre></dd>

          <dt>Actor</dt>
          <dd>{this.renderObject(event.actor)}</dd>

          <dt>Context</dt>
          <dd>{this.renderObject(event.context)}</dd>

          <dt>Diff</dt>
          <dd>{this.renderDiff(event.diff)}</dd>
        </dl>
      </div>
    );
  }

  render() {
    const { onClose } = this.props;

    return (
      <Modal
        show
        size="lg"
        onDismiss={onClose}
        aria-labelledby="event-modal"
      >
        <Modal.Header>
          <Modal.Title>Event Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {this.renderBody()}
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={onClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}
